<template lang="pug">
  v-layout(column align-center)
    //- LOADER PROCESS
    v-dialog(v-model="loader.flag" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | {{loader.text}}
          v-progress-linear.mb-0(indeterminate="" color="white")
    v-flex(style="margin:1em")
      v-layout( align-center justify-center row fill-height)
        v-flex.box-date-eec-formatter(style="width:15em;margin-right:0.5em")
          label.box-label Selecciona el mes
          v-img.box-icon(style="z-index: 1;")
            img(:src="iconlistFlag")
          v-dialog(ref='dialogStartEECC' v-model='eecc.modalStart' :return-value.sync="eecc.startDate" persistent lazy full-width width='290px')
            template(v-slot:activator="{ on }")
              v-text-field(
                style="z-index: 2;"
                slot='activator'
                hide-details
                v-model="eecc.textFieldStartDate"
                outline readonly v-on="on")
            v-date-picker(v-model="eecc.startDate" locale="es-005" :min="eecc.minDate" :max="eecc.maxDate" type='month' scrollable)
              v-spacer
              v-btn(flat color='primary' @click="eecc.modalStart = false") Cancel
              v-btn(flat color='primary' @click="$refs.dialogStartEECC.save(eecc.startDate)") OK
    v-flex(style="margin: 2em 0em")
      v-btn( @click="downloadStatusAccount" style="background: #EA0D90;border-radius: 3px;width: 17em;height: 3.5em;")
        span(style="color: #ffffff;text-transform: initial;") Descargar
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import Functionalities from '../../interfaces/functionalities'

export default {
  props: [
    'ceProp',
    'poliza',
    'taggeo'
  ],
  watch: {
    'eecc.startDate': function () {
      this.eecc.textFieldStartDate = moment(this.eecc.startDate).locale('es').format('MMM-YYYY').split('.').join('')
    },
    'eecc.endDate': function () {
      this.eecc.textFieldEndDate = moment(this.eecc.endDate).locale('es').format('MMM-YYYY').split('.').join('')
    },
    'ce.startDate': function (val) {
      let minDateAvailable = moment('2018-12-31')
      let startDateSelected = moment(val + '-01')
      if (startDateSelected.isAfter(minDateAvailable)) {
        this.ce.textFieldStartDate = moment(this.ce.startDate).locale('es').format('MMM-YYYY').split('.').join('')
      } else {
        this.ce.modalStart = false
        this.messageLoader = true
      }
    },
    'ce.endDate': function (val) {
      let minDateAvailable = moment('2018-12-31')
      let endDateSelected = moment(val + '-01')
      if (endDateSelected.isAfter(minDateAvailable)) {
        this.ce.textFieldEndDate = moment(this.ce.endDate).locale('es').format('MMM-YYYY').split('.').join('')
      } else {
        this.ce.modalEnd = false
        this.messageLoader = true
      }
    }
  },
  data () {
    return {
      ce: [],
      eecc: {
        maxDate: null,
        minDate: null,
        modalStart: false,
        modalEnd: false,
        startDate: null,
        endDate: null,
        textFieldStartDate: null,
        textFieldEndDate: null
      },
      iconlistFlag: require('./../../assets/icons-mis-seguros/icon-round-navigate-next.svg'),
      loader: {
        flag: false,
        text: 'Cargando la página...'
      },
      metadata: {}
    }
  },
  mounted () {
    let self = this
    self.metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Plan - Mi estado de cuenta', metadata: self.metadata})

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'mobile',
        'seccion': 'ec'
      }
    })

    // maxDate según frecuencia de pago
    switch ((this.poliza.frecuenciaPago || '').toLowerCase()) {
    case 'anual':
      this.eecc.maxDate = moment().subtract(1, 'year').subtract(1, 'months').format('YYYY-MM')
      break
    case 'semestral':
      this.eecc.maxDate = moment().subtract(6, 'months').format('YYYY-MM')
      break
    case 'trimestral':
      this.eecc.maxDate = moment().subtract(3, 'months').format('YYYY-MM')
      break
    default:
      this.eecc.maxDate = moment().subtract(1, 'months').format('YYYY-MM')
      break
    }

    self.ce.maxDate = moment().format('YYYY-MM')
    let minArrDate = this.poliza.fechaVigencia.split('/')
    this.eecc.minDate = self.ce.minDate = minArrDate[2] + '-' + minArrDate[1]
    // TMP: Verificar si tienen fecha de inicio/fin de vigencia
    this.poliza.asegurado = this.poliza.asegurado === null ? '-' : this.poliza.asegurado
    this.poliza.fechaIniVidaEstadoCta = this.poliza.fechaIniVidaEstadoCta === null ? new Date() : this.poliza.fechaIniVidaEstadoCta
    this.poliza.fechaFinVidaEstadoCta = this.poliza.fechaFinVidaEstadoCta === null ? new Date() : this.poliza.fechaFinVidaEstadoCta
    this.eecc.startDate = moment(this.poliza.fechaIniVidaEstadoCta, 'DD-MM-YYYY')
    this.eecc.endDate = moment(this.poliza.fechaFinVidaEstadoCta, 'DD-MM-YYYY').subtract(1, 'months').format('YYYY-MM')
    // TMP: Fechas para comprobante electronico
    self.ce.startDate = moment(new Date(), 'DD-MM-YYYY').subtract(1, 'months').format('YYYY-MM')
    self.ce.endDate = moment(new Date(), 'DD-MM-YYYY').format('YYYY-MM')

    // Condicionales de fecha para Estado de cuenta
    switch (this.poliza.frecuenciaPago.toUpperCase()) {
    case 'ANUAL':
      this.eecc.startDate = moment(this.poliza.fechaFinVidaEstadoCta, 'DD-MM-YYYY').add(-1, 'months').subtract(1, 'year').format('YYYY-MM')
      break
    case 'MENSUAL':
      this.eecc.startDate = moment(this.poliza.fechaFinVidaEstadoCta, 'DD-MM-YYYY').subtract(1, 'months').format('YYYY-MM')
      break
    case 'TRIMESTRAL':
      this.eecc.startDate = moment(this.poliza.fechaFinVidaEstadoCta, 'DD-MM-YYYY').subtract(3, 'months').format('YYYY-MM')
      break
    case 'SEMESTRAL':
      this.eecc.startDate = moment(this.poliza.fechaFinVidaEstadoCta, 'DD-MM-YYYY').subtract(6, 'months').format('YYYY-MM')
      break
    case 'PAGOUNICO':
    case 'PRIMAPAGOUNICO':
      this.eecc.startDate = moment(this.poliza.fechaFinVidaEstadoCta, 'DD-MM-YYYY').subtract(1, 'year').format('YYYY-MM')
      break
    default:
      this.eecc.startDate = moment(this.poliza.fechaIniVidaEstadoCta, 'DD-MM-YYYY').format('YYYY-MM')
      break
    }
  },
  methods: {
    ...mapActions('user', ['getPDFPolizaVida']),
    ...mapActions('event', ['eventLog']),
    downloadStatusAccount () {
      let self = this
      if (!Functionalities.isAvailable(Functionalities.vida.EECC, self.functionsRules, self)) {
        return
      }

      this.loader.flag = true
      this.loader.text = 'Descargando estado de cuenta...'
      let start = this.eecc.startDate.split('-')
      let end = this.eecc.startDate.split('-')
      let startDate = moment([start[0], start[1] - 1])
      let endDate = moment([end[0], end[1]])

      // Periodo de Estado de Cuenta en consulta
      startDate = moment(this.eecc.startDate).startOf('month')
      switch (this.poliza.frecuenciaPago.toUpperCase()) {
      case 'ANUAL':
        endDate = moment(this.eecc.startDate).add(1, 'year').subtract(1, 'days')
        break
      case 'SEMESTRAL':
        endDate = moment(this.eecc.startDate).add(6, 'months').subtract(1, 'days')
        break
      case 'TRIMESTRAL':
        endDate = moment(this.eecc.startDate).add(3, 'months').subtract(1, 'days')
        break
      case 'MENSUAL':
        endDate = moment(this.eecc.startDate).endOf('month')
        break
      default:
        endDate = moment(this.eecc.endDate).endOf('month')
        break
      }

      // EVENT TRACK  Universal Analytics
      // EVENT UPDATE 29
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Mi seguros - Estado de cuenta',
        label: 'Seleccionar botón - Descargar'
      })
      // EVENT TRACK  GA4
      // EVENT UPDATE 29
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Mi seguros - Estado de cuenta',
        CTA: 'Seleccionar botón - Descargar'
      })
      if (startDate.isAfter(endDate)) {
        this.loader.flag = false
        this.$swal({
          title: 'Atención',
          text: 'La fecha de inicio debe ser menor a la fecha de fin.',
          confirmButtonText: 'Salir'
        })
        return
      }
      // TRACK EVENT - AMPLITUDE
      /* var productoConsultado = ''
      if (this.poliza.oriProducto === null) {
        if (this.poliza.modalidad === null) {
          productoConsultado = this.poliza.producto
        } else {
          productoConsultado = this.poliza.modalidad
        }
      } else {
        productoConsultado = this.poliza.oriProducto
      } */
      this.getPDFPolizaVida({ 'codigoProducto': self.poliza.codigoProducto, 'numeroPoliza': self.poliza.numeroPoliza, 'codigoUsuario': this.userInfo.codigoUsuario, 'fechaInicio': startDate.format('DD/MM/YYYY'), 'fechaFin': endDate.format('DD/MM/YYYY') })
        .then(() => {
          /*
          this.$gtm.trackEvent({
            event: 'Descarga EC',
            category: 'Zona Privada',
            action: 'Estado de Cuenta',
            label: 'Descarga del Estado de Cuenta'
          })
          this.$amplitude.getInstance()
            .logEvent(
              this.amplitude.events.downloadDocuments,
              {
                'Tipo Documento': 'Estado de Cuenta',
                'Producto Consultado': productoConsultado,
                'Meses consultados': [start[1], end[1]]
              }
              )
          */
          this.loader.flag = false
          setTimeout(() => {
            self.$root.$emit('showNps', {
              nombre: 'NPS - Inicio de Encuesta',
              funcionalidad: 'Descarga de Estado de Cuenta',
              metadata: self.metadata
            })
          }, 3000)
        })
        .catch((err) => {
          this.loader.flag = false
          this.$swal({
            imageUrl: require('@/assets/characters/sorprendido.svg'),
            title: '¡Lo sentimos!',
            text: 'Algo salió mal. Por favor, vuelve a intentarlo en unos minutos.',
            confirmButtonText: 'Salir'
          })
          setTimeout(() => {
            self.$root.$emit('showNps', {
              nombre: 'NPS - Inicio de Encuesta',
              funcionalidad: 'Descarga de Estado de Cuenta',
              metadata: { ...self.metadata, error: err }
            })
          }, 3000)
        })
    }
  },
  computed: {
    ...mapGetters('user', ['userInfo']),
    ...mapGetters('user', ['functionsRules'])
  },
  components: {
  }
}
</script>

<style >
.box-date-eec-formatter {
  position: relative
}

.box-date-eec-formatter .box-label {
  font-size: 13px;
}

.box-date-eec-formatter .theme--light.v-input:not(.v-input--is-disabled) input {
  color: #1F1F1F !important;
  margin: auto !important;
  text-align: center !important;
  cursor: pointer;
}

.box-date-eec-formatter .theme--light.v-text-field--outline>.v-input__control>.v-input__slot {
  background: #FFFFFF !important;
  border: 1px solid #919191 !important;
  border-radius: 3px !important;
  min-height: 2.5em;
  height: 2.5em;
}

.box-date-eec-formatter .theme--light.v-text-field--outline>.v-input__control>.v-input__slot:hover {
  background-color: #ffffff00 !important;
  border: 1px solid #0855C4 !important;
}

.box-date-eec-formatter .box-icon {
  position: absolute;
  right: 0.5em;
  top: 1.6em;
  transform: rotate(90deg);
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/EstadoDeCuenta.vue